import { Flex, FlexProps, Box, BoxProps } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import Footer from './Footer';
import Header from './Header';

export interface BackgroundProps extends BoxProps {
  $bgFile?: string;
}

const ContentContainer = styled(Flex)<FlexProps>`
  box-sizing: border-box;
  padding: ${(props) =>
    `${props.theme.space['s']} ${props.theme.space['s-m']} ${props.theme.space['s-m']}`};
`;

const Wrapper = styled.div`
  position: relative;
`;

const Background = styled(Box)<BackgroundProps>`
  position: fixed;
  top: 0;
  right: 0;
  max-width: 1010px;
  height: 100%;
  z-index: -1;

  background-repeat: no-repeat;
  background-size: contain;
  background-position: top right;
  background-image: url('/assets/background-lines.svg');
`;

const ColorSquare = styled(Box)<BoxProps>`
  aspect-ratio: 1 / 1;
  background-image: linear-gradient(to right, #fa43bd, #ffa480, #ffffff);
  filter: blur(384px);
  transform: matrix(1, 0, 0, 1, 643, 66);
`;

export default function Layout({ children }: { children?: ReactNode }) {
  return (
    <Wrapper>
      <Background width={['200vw', '150vw', '125vw', '100%']}>
        <ColorSquare width={['70vw', '70vw', '367px', '367px']} />
      </Background>
      <ContentContainer
        flexGrow={1}
        flexShrink={1}
        flexBasis={['100%', 'auto']}
        margin="0 auto"
        width="100%"
        maxWidth={['100vw', '80rem']}
        flexDirection="column"
        justifyContent="space-between"
        gap="m">
        <Header />

        <main>{children ? children : <Outlet />}</main>

        <Footer />
      </ContentContainer>
    </Wrapper>
  );
}
